import { Survey, SurveyKind } from '@ps/survey-utils';

/**
 * What picking a child means per survey type:
 * `route` changes the URL id (traditional MC), `select` keeps the
 * parent id and only moves the active child (project-backed types).
 */
export type ChildSelection =
  | { readonly kind: 'route'; readonly surveyId: number }
  | { readonly kind: 'select'; readonly surveyId: number };

export function childSelection(
  survey: Survey,
  surveyId: number,
): ChildSelection {
  return SurveyKind.isProject(survey)
    ? { kind: 'select', surveyId }
    : { kind: 'route', surveyId };
}
